import React from "react";
import { PropertyEditorSelect, PropertyEditorSelectInterface } from "../PropertyEditorSelect";
import { StoryNode } from "../../StoryBook/StoryData";
import { IDesignValidationProvider, ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

class SelectData implements PropertyEditorSelectInterface {
    editObject: object = {};
    hint: string = "hint";
    label: string = "Select Editor";
    options: string[] = ["Option a", "Option b"];
    parentDefaultValue: string = "";
    propertyName: string = "propName";
    requiredText: string = "required text";
}

let args = new SelectData();

class SelectData2 implements PropertyEditorSelectInterface {
    editObject: IDesignValidationProvider = {
        getDesignValidationIssues(): ValidationIssue[] {
            return [new ValidationIssue("issue", "propName"), new ValidationIssue("issue2", "propName")];
        },
    };
    hint: string = "hint";
    label: string = "Select Editor";
    options: string[] = ["Option a", "Option b"];
    parentDefaultValue: string = "";
    propertyName: string = "propName";
    requiredText: string = "required text";
}

let args2 = new SelectData2();
export const SelectPropertyEditor = [
    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorSelect
                    {...args}
                    onChange={() => {
                        logCallback(Reflect.get(args.editObject, args.propertyName));
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Select",
        "Default",
    ),

    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorSelect
                    {...args}
                    error={"error text"}
                    onChange={() => {
                        logCallback(Reflect.get(args.editObject, args.propertyName));
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Select",
        "Error",
    ),
    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorSelect
                    {...args2}
                    onChange={() => {
                        logCallback(Reflect.get(args.editObject, args.propertyName));
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Select",
        "Validation Provider",
    ),
];
